export default __webpack_public_path__ + "static/media/img-0251-afghanistan-full-face.ac4ccbab.png";